export const LineVariableNames = {
  'wst-system-line-1-color': 'wst-system-line-1-color',
  'wst-system-line-1-width': 'wst-system-line-1-width',
  'wst-system-line-2-color': 'wst-system-line-2-color',
  'wst-system-line-2-width': 'wst-system-line-2-width'
};
//# sourceMappingURL=line.js.map